import PageAbstract from '../PageAbastract'
import store from '@/store'
import { BILL_TYPES } from '@/class/cargo/model/parameters/BillType'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getObjectByCache } from '@/utils/basicDataCache'

const isZh = store.getters.language === 'zh'

export default class SeaBookingMbl extends PageAbstract {
  constructor(job, formData) {
    super(job, formData)
  }

  async loadElement(elementName) {
    let e = null
    switch (elementName) {
      case 'typeMBL': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          props: {
            no: elementName,
            options: [...BILL_TYPES],
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code'
          }
        }
        const formCallback = () => { e.hide = this.formData.docType !== 'MBL' }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'syncContainerInfoTotal': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/mbl/syncContainerInfoTotal'))?.default,
          props: {
            job: this.job,
            cargoDoc: this.formData
          }
        }
        const jobCallback = () => { e.props.job = this.job }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinJobWatchList(jobCallback)
        this.joinFormWatchList(formCallback)
        jobCallback()
        formCallback()
        break
      }
      case 'vesselVoyage': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'sailingDate': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'lblCfrState': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'billLadingIssued': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'lblReleaseState': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'requestReleaseState': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'releaseEligibleStatus': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'portRequirement': {
        e = {
          elementName,
          component: 'el-input',
          props: {
            type: 'textarea',
            rows: 5
          }
        }
        break
      }
      case 'paymentTermMBL': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          disabled: true,
          props: {
            no: elementName,
            selectType: TYPE_NAMES.basic_data_PaymentTerm,
            filterable: true
          }
        }
        break
      }
      case 'paymentPlaceBL': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'freightTerm': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'dispatchingPlaceCode': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/cargoDoc/dispatchingPlaceCode'))?.default,
          props: {}
        }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'loadingPortCode': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/cargoDoc/loadingPortCode'))?.default,
          props: {}
        }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'dischargingPortCode': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/cargoDoc/dischargingPortCode'))?.default,
          props: {}
        }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'destinationPortCode': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/se/cargoDoc/destinationPortCode'))?.default,
          props: {}
        }
        const formCallback = () => { e.props.cargoDoc = this.formData }
        this.joinFormWatchList(formCallback)
        formCallback()
        break
      }
      case 'reviewDate': {
        e = {
          elementName,
          component: 'el-date-picker',
          disabled: true,
          props: {}
        }
        break
      }
      case 'surrenderedNo': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'withholdReason': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {
            type: 'textarea',
            rows: 5
          }
        }
        break
      }
      case 'txtCarrierScAc': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        const callback = () => {
          const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.carrierId)
          this.formData.txtCarrierScAc = company ? company.scac : ''
        }
        this.joinFieldWatchList('job.carrierId', callback)
        callback()
        break
      }
      case 'txtBookingAgentScAc': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        const callback = () => {
          const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.destinationAgent)
          this.formData.txtBookingAgentScAc = company ? company.scac : ''
        }
        this.joinFieldWatchList('job.destinationAgent', callback)
        callback()
        break
      }
      case 'releaseDate': {
        e = {
          elementName,
          component: 'el-date-picker',
          disabled: true,
          props: {}
        }
        break
      }
    }
    if (e) {
      this.elementMap.set(elementName, e)
    }
    return e
  }
}
